/* @flow */

import * as types from 'src/shared/app/onboarding/action/uiOnboardingActionTypes';
import { createReducer } from 'src/shared/core/util/reducerUtils';

const initialState = {
  isSplashSeen: false,
  isCompletedOnDevice: false,
};

const markSplashAsSeen = (state: Object) => ({
  ...state,
  isSplashSeen: true,
});

const completeOnDevice = (state: Object) => ({
  ...state,
  isCompletedOnDevice: true,
});

const resetOnDevice = (state: Object) => ({
  ...state,
  isCompletedOnDevice: false,
});

export default createReducer(initialState, {
  [types.MARK_SPLASH_AS_SEEN]: markSplashAsSeen,
  [types.COMPLETE_ONBOARDING_ON_DEVICE]: completeOnDevice,
  [types.RESET_ONBOARDING_ON_DEVICE]: resetOnDevice,
});
